// extracted by mini-css-extract-plugin
export default {"stickySidebar":"UserNavigation_stickySidebar__e4620"};